import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from "styled-components";
import { THEME } from 'Util/constants';
import { EditFilled } from '@ant-design/icons';
import { selectedSpecies } from "Store/procurementAtom";
import { useRecoilState } from 'recoil';
import { useHistory } from "react-router-dom";

const Container = styled.div`
    cursor: pointer;
    .anticon{
        color: ${THEME.colors.primary};
        margin-right: 5px;
    }
    label{
        font-weight: bold;
    }
    
`;


function Edit(props) {
    const [species, setSelectedSpecies] = useRecoilState(selectedSpecies);
    const history = useHistory()

    const onClick = () => {
        if (!species.id) return
        history.push(`/wholesale/species-database/new/edit/${species.id}`)
    };

    return (
        <Container>
            <EditFilled onClick={onClick} />
            <label>Edit</label>
        </Container>
    )
}

Edit.propTypes = {}

export default Edit